export const _1K = 1000;
export const _1M = 1000000;
export const _1B = 1000000000;

export const ANDROID = 'Android';
export const IOS = 'iOS';
export const OTHER_PLATFORMS = 'unknown';
export const DESKTOP = 'Desktop';

export const EASY_CHART_LAYOUT = 'easyChartLayout';
export const EASY_CHART_SYMBOL = 'easyChartSymbol';
export const EASY_CHART_ADJ = 'myAdjustmentType';
export const EASY_CHART_STATE_OBJ = 'myEasyChartStateObject';

export const ACTIVE_STOCK_CHANGE_DEBOUNCE_TIME = 200;

export const MIN_AVAILABLE_TIME = -8640000000000000;

export const MIN_TSE_DATE: Date = new Date(2006, 2, 21);
export const ReleaseNotePageSize = 15;
export const MarketOpenTime = 825;
export const MarketCloseTime = 1500;
export const TradeOpenTime = 830;
export const ShowMarketOpenTime = 824;
export const STORE_EXPIRE_DEFAULT = 5000;

class UserBrowserValidator {
	private desktopValidVersion: number;
	private mobileValidVersion: number;
	constructor(desktopVersion, mobileVersion) {
		this.desktopValidVersion = desktopVersion;
		this.mobileValidVersion = mobileVersion;
	}
	public isValid(isMobile, currentVersion) {
		return this.checkBrowserVersion(currentVersion, isMobile ? this.mobileValidVersion : this.desktopValidVersion);
	}
	checkBrowserVersion(currentVersion, validVersion) {
		return currentVersion >= validVersion;
	}
}

export const VALID_BROWSER_VERSIONS = new Map<string, UserBrowserValidator>([
	['chrome', new UserBrowserValidator(72.0, 71.0)],
	['edge', new UserBrowserValidator(79.0, 79.0)],
	['firefox', new UserBrowserValidator(69.0, 79.0)],
	['opera', new UserBrowserValidator(58.0, 50.0)],
	// ['safari', new UserBrowserValidator(12.1, 12.1)],
	['samsung', new UserBrowserValidator(10.0, 10.0)]
]);

export const VALID_OS_VERSIONS = new Map<string, number>([
	['android', 4.2],
	['ios', 12.0]
]);

export const DownloadBrowsersLinksInfo = [
	{
		browserName: 'chrome',
		linksInfo: [
			{
				os: 'android',
				icon: 'assets/images/bazzar.svg',
				link: 'https://cafebazaar.ir/app/com.android.chrome',
				linkTitle: 'لینک بازار'
			},
			{
				os: 'android',
				icon: 'assets/images/google-play.svg',
				link: 'https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_IN&pli=1',
				linkTitle: 'لینک گوگل'
			},
			{
				os: 'ios',
				icon: 'assets/images/apple.svg',
				link: 'https://apps.apple.com/us/app/google-chrome/id535886823',
				linkTitle: 'اپ استور'
			},
			{
				os: 'ios',
				icon: 'assets/images/sibche.svg',
				link: 'https://sibche.com/applications/google-chrome',
				linkTitle: 'سیب چ'
			},
			{
				os: 'desktop',
				icon: 'assets/images/link.svg',
				link: 'https://www.google.com/chrome/',
				linkTitle: 'دانلود مرورگر'
			}
		]
	},
	{
		browserName: 'safari',
		linksInfo: [
			{
				os: 'ios',
				icon: 'assets/images/apple.svg',
				link: 'https://apps.apple.com/us/app/safari/id1146562112',
				linkTitle: 'اپ استور'
			},
			{
				os: 'desktop',
				icon: 'assets/images/link.svg',
				link: 'https://apps.apple.com/us/app/safari/id1146562112',
				linkTitle: 'دانلود مرورگر'
			}
		]
	},
	{
		browserName: 'firefox',
		linksInfo: [
			{
				os: 'ios',
				icon: 'assets/images/apple.svg',
				link: 'https://apps.apple.com/us/app/firefox-private-safe-browser/id989804926',
				linkTitle: 'اپ استور'
			},
			{
				os: 'android',
				icon: 'assets/images/bazzar.svg',
				link: 'https://cafebazaar.ir/app/org.mozilla.firefox',
				linkTitle: 'کافه بازار'
			},
			{
				os: 'android',
				icon: 'assets/images/google-play.svg',
				link: 'https://play.google.com/store/apps/details?id=org.mozilla.firefox&hl=en&gl=US',
				linkTitle: 'گوگل پلی'
			},
			{
				os: 'desktop',
				icon: 'assets/images/link.svg',
				link: 'https://www.mozilla.org/en-US/firefox/new/',
				linkTitle: 'دانلود مرورگر'
			}
		]
	},
	{
		browserName: 'edge',
		linksInfo: [
			{
				os: 'ios',
				icon: 'assets/images/apple.svg',
				link: 'https://apps.apple.com/us/app/microsoft-edge-web-browser/id1288723196',
				linkTitle: 'اپ استور'
			},
			{
				os: 'android',
				icon: 'assets/images/bazzar.svg',
				link: 'https://cafebazaar.ir/app/com.microsoft.emmx',
				linkTitle: 'کافه بازار'
			},
			{
				os: 'desktop',
				icon: 'assets/images/link.svg',
				link: 'https://www.microsoft.com/en-us/edge?form=MA13FJ&exp=e00',
				linkTitle: 'دانلود مرورگر'
			}
		]
	},
	{
		browserName: 'opera',
		linksInfo: [
			{
				os: 'ios',
				icon: 'assets/images/apple.svg',
				link: 'https://apps.apple.com/us/app/opera-browser-private-vpn/id1411869974',
				linkTitle: 'اپ استور'
			},
			{
				os: 'android',
				icon: 'assets/images/google-play.svg',
				link: 'https://play.google.com/store/apps/details?id=com.opera.browser&hl=en&gl=US',
				linkTitle: 'گوگل پلی'
			},
			{
				os: 'desktop',
				icon: 'assets/images/link.svg',
				link: 'https://www.opera.com/download',
				linkTitle: 'دانلود مرورگر'
			}
		]
	},
	{
		browserName: 'samsung',
		linksInfo: [
			{
				os: 'android',
				icon: 'assets/images/bazzar.svg',
				link: 'https://cafebazaar.ir/app/com.sec.android.app.sbrowser',
				linkTitle: 'کافه بازار'
			},
			{
				os: 'android',
				icon: 'assets/images/google-play.svg',
				link: 'https://play.google.com/store/search?q=samsung%20browser&c=apps&hl=en&gl=US',
				linkTitle: 'گوگل پلی'
			}
		]
	}
];
